import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Username ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Password ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "login-button"
}, "Login", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
    class: "login"
  }, [
    _createElementVNode("div", null, [
      _hoisted_1,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
        class: "form-control",
        placeholder: "Username",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.form.username]
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_2,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
        class: "form-control",
        type: "password",
        placeholder: "Password",
        required: ""
      }, null, 512), [
        [_vModelText, _ctx.form.password]
      ])
    ]),
    _createElementVNode("div", null, _toDisplayString(_ctx.userStore.state.error), 1),
    _hoisted_3
  ], 32))
}